import React from 'react';
import { Slider, Space, Card, Typography, Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';

const { Text } = Typography;

interface LabeledRangeSliderProps {
    title: string;
    emoji?: string;
    min: number;
    max: number;
    values: [number, number];
    onChange: (values: [number, number]) => void;
    labels?: string[];
    unit?: string;
    step?: number;
    marks?: {
        [key: number]: string;
    };
}

const LabeledRangeSlider: React.FC<LabeledRangeSliderProps> = ({
    title,
    emoji,
    min,
    max,
    values,
    onChange,
    labels,
    unit,
    step = 1,
    marks = {}
}) => {
    // État local pour l'affichage en temps réel pendant le glissement
    const [localValues, setLocalValues] = React.useState<[number, number]>(values);

    // Synchroniser avec les valeurs externes quand elles changent
    React.useEffect(() => {
        setLocalValues(values);
    }, [values]);

    const isActive = localValues[0] !== min || localValues[1] !== max;

    return (
        <Card size="small" style={{ marginBottom: 8 }}>
            <Space direction="vertical" style={{ width: '100%' }} size="small">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Text strong style={{ fontSize: 12 }}>
                        {emoji && `${emoji} `}{title}
                    </Text>
                    {isActive && (
                        <Button
                            type="text"
                            size="small"
                            icon={<CloseOutlined />}
                            onClick={() => {
                                setLocalValues([min, max]);
                                onChange([min, max]);
                            }}
                            style={{ padding: 0, height: 'auto' }}
                        />
                    )}
                </div>
                <Slider
                    range
                    min={min}
                    max={max}
                    marks={marks}
                    step={step}
                    value={localValues}
                    onChange={(val) => {
                        // Mise à jour locale pour l'affichage en temps réel
                        setLocalValues(val as [number, number]);
                    }}
                    onAfterChange={(val) => {
                        // Mise à jour réelle seulement quand on relâche
                        onChange(val as [number, number]);
                    }}
                    tooltip={{
                        formatter: (value) => labels ? (labels[value || 0] || '') : (value || 0).toString()
                    }}
                />
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11 }}>
                    <Text type="secondary" style={{ fontSize: 11 }}>
                        De: <Text strong style={{ color: '#1890ff' }}>
                            {labels ? (labels[localValues[0]] || '') : localValues[0] + (unit ? ` ${unit}` : '')}
                        </Text>
                    </Text>
                    <Text type="secondary" style={{ fontSize: 11 }}>
                        À: <Text strong style={{ color: '#1890ff' }}>
                            {labels ? (labels[localValues[1]] || '') : localValues[1] + (unit ? ` ${unit}` : '')}
                        </Text>
                    </Text>
                </div>
            </Space>
        </Card>
    );
};

export default LabeledRangeSlider;
